<div class="widget widget_search">
    <form class="search-form">
        <label for="search-form">
            <span class="screen-reader-text">Search for:</span>
        </label>
        <input type="search" id="search-form" class="search-field" placeholder="Search &hellip;" value="" name="s" />
        <button type="submit" class="search-submit"><i class="fa fa-search"></i><span class="screen-reader-text">Search</span></button>
    </form>
</div>